import { NavLinkTabsContainer } from '@gasbi/shared/web/components/NavLinkTabs';

export {
  NavLinkTabs,
  NavLinkTabsContainer,
} from '@gasbi/shared/web/components/NavLinkTabs';
export type {
  NavTabLink,
  NavLinkTabsProps,
} from '@gasbi/shared/web/components/NavLinkTabs';

export default NavLinkTabsContainer;
